<template>
  <div class="container">
    <div v-if="!loaded">Ładowanie formularza</div>

    <div v-else-if="sent">
      <div class="alert rezerwacja-ok">
        <h2>Dziękujemy za złożenie rezerwacji.</h2>

        <p>
          Twoja rezerwacja została zapisana. <br />
          Na podany adres mailowy otrzymasz za chwilę potwierdzenie.
        </p>
      </div>
    </div>

    <div v-else>
      <development>{{ $schema.$getData() }}</development>

      <Stepper
        ref="stepper"
        role="region"
        aria-label="Kroki rezerwacji"
        :active-step="activeStep"
        :steps="steps"
        @change="gotoStep"
      />

      <StepperStep
        :active-step="activeStep"
        :show-buttons="steps[0].buttons"
        :step="0"
        :steps="steps"
        @set-step="gotoStep"
      >
        <StepDatesRooms :schema="$schema" :settings="settings" @completed="toAdditions" />
        <div ref="afterStepDatesRooms" />
      </StepperStep>

      <StepperStep :active-step="activeStep" :step="1" :steps="steps" @set-step="gotoStep">
        <StepAdditions :schema="$schema" :additions="additions" :settings="settings" />
      </StepperStep>

      <StepperStep :active-step="activeStep" :step="2" :steps="steps" @set-step="gotoStep">
        <StepBookerData :schema="$schema" :settings="settings" />
      </StepperStep>

      <StepperStep :active-step="activeStep" :step="3" :steps="steps" @set-step="gotoStep">
        <StepOrder :schema="$schema" :settings="settings" @submit="submitReservation" />
      </StepperStep>
    </div>
  </div>
</template>

<script>
import { schemaMixin } from '@witkac/jschema';
import dayjs from 'dayjs';

import StepAdditions from '@/components/form/StepAdditions';
import StepBookerData from '@/components/form/StepBookerData';
import StepDatesRooms from '@/components/form/StepDatesRooms';
import StepOrder from '@/components/form/StepOrder';
import Stepper from '@/components/stepper/Stepper';
import StepperStep from '@/components/stepper/StepperStep';
import { stepperMixin } from '@/mixins/stepper';
import schema from '@/schema.json';
import reservationService from '@/services/reservation.service';
import roomService from '@/services/room.service';

export default {
  components: { StepAdditions, StepBookerData, StepDatesRooms, StepOrder, Stepper, StepperStep },
  mixins: [schemaMixin, stepperMixin],
  schema,
  external: {},
  data() {
    return {
      activeStep: 0,
      loaded: false,
      sent: false,
      settings: {},
      steps: [
        { title: 'Wybór terminu i pokoju', buttons: false },
        { title: 'Dodatki', buttons: true },
        { title: 'Dane rezerwującego', buttons: true },
        { title: 'Rezerwacja', buttons: true }
      ],
      model: {
        start: dayjs().startOf('day').toDate(),
        end: undefined
      },
      additions: []
    };
  },
  computed: {
    minDate() {
      return dayjs().startOf('day').toDate();
    }
  },
  methods: {
    async toAdditions() {
      this.additions = await Promise.all(
        this.$schema.occupancy.$items.map(occupancy =>
          roomService.additions(occupancy.$item.room.id.$value).then(additions => ({
            id: occupancy.$item.room.id.$model,
            name: occupancy.$item.room.name.$model,
            additions
          }))
        )
      );
      if (this.$schema.occupancy.$items.length === 1) {
        this.gotoStep(1);
        return;
      }
      this.steps[0].buttons = true;
      this.$nextTick(() => {
        if (this.$refs.afterStepDatesRooms) {
          this.$scrollTo(this.$refs.afterStepDatesRooms);
        }
      });
    },
    gotoStep(step) {
      if (this.activeStep === 2 && step === 3) {
        const customerDataErrors = [...this.$schema.customer.$validateAll(), ...this.$schema.invoice.$validateAll()];
        if (customerDataErrors.length) {
          return;
        }
      }
      this.setStep(step);
      this.$scrollTo(this.$refs.stepper);
    },
    submitReservation() {
      const data = this.$schema.$getData();
      reservationService
        .submitReservation(data)
        .then(response => {
          if(response.redirect){
            window.location.href = response.redirect;
            return;
          }
          this.sent = true;
        })
        .catch(err => {
          console.error(err);
          alert(`ERROR: ${err.message}`);
        });
    }
  },
  mounted() {
    this.loaded = false;
    reservationService.loadSettings().then(settings => {
      this.$schema.occupancy.$setLength(1);

      this.settings = settings;
      this.loaded = true;
    });
  }
};
</script>
